export default {
  events (state) {
    return {
      ...state,
      storeName: 'events'
    }
  }
}
